import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API, errMsg, setSession } from "@/lib/api";
import { Logo, BackButton } from "@/components/fly/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/auth/admin-login`, { email, password });
      setSession(data);
      nav("/organizacja");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full h-12 px-4 rounded-xl bg-[#1C2541] border border-blue-500/20 focus:border-blue-500 outline-none";
  return (
    <main className="max-w-md mx-auto px-5 py-10">
      <div className="flex items-center gap-4"><BackButton /><Logo /></div>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400 mt-12">FLY CUP 2026 · tylko dla administratora</p>
      <h1 className="font-display text-4xl font-extrabold uppercase mt-2" data-testid="admin-panel-title">Panel administracyjny</h1>
      <p className="text-sm text-slate-400 mt-2">Po zalogowaniu przejdziesz do panelu Organizacja.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="admin-email-input" type="email" required placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={input} />
        <input data-testid="admin-password-input" type="password" required placeholder="Hasło" value={password} onChange={(e) => setPassword(e.target.value)} className={input} />
        <button data-testid="admin-login-submit" disabled={busy}
          className="w-full h-14 rounded-xl bg-blue-600 hover:bg-blue-500 font-display text-xl font-bold uppercase tracking-wider shadow-lg shadow-blue-600/30 disabled:opacity-50 flex items-center justify-center gap-2 transition-colors">
          {busy && <Loader2 className="w-5 h-5 animate-spin" />} Zaloguj
        </button>
      </form>
    </main>
  );
}
